import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { ManageComponent } from './manage.component';
import { UsersComponent } from './users/users.component';
import { CompaniesComponent } from './companies/companies.component';
import { FracSpreadComponent } from './frac-spread/frac-spread.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { HistoricalWellsComponent } from './historical-wells/historical-wells.component';

const routes: Routes = [{
  path: '',
  component: ManageComponent,
  children: [
    {
      path: 'companies',
      component: CompaniesComponent,
    },
    {
      path: 'historicalWells',
      component: HistoricalWellsComponent,
    },
    {
      path: 'users',
      component: UsersComponent,
    },
    {
      path: 'fracSpread',
      component: FracSpreadComponent,
    },
    {
      path: 'equipments',
      component: EquipmentComponent,
    },
    {
      path: '',
      redirectTo: 'companies',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageRoutingModule {
}
